import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  FormControlLabel,
  IconButton,
  Switch,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import Header from "components/Header";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAddKaryawanBaru,
  fetchChangeActiveKaryawan,
  fetchDeleteKaryawan,
  fetchListCabang,
  fetchListKaryawan,
  fetchListKaryawanWeb,
  fetchOptionsKaryawanWeb,
  fetchSendNotifBirthday,
} from "state/karyawanActions";
import {
  Delete,
  Edit,
  Groups2Outlined,
  Info,
  Password,
  FilterList,
  NotificationsActive,
} from "@mui/icons-material";
import MUIDataTable from "mui-datatables";
import FlexBetween from "components/FlexBetween";
import FloatingAlert from "components/FloatingAlert";
import { setMessage, setStatus } from "state";
import KonfirmasiModal from "components/Modals/KonfirmasiModal";
import DetailKaryawanModal from "components/Modals/DetailKaryawanModal";
import { fetchListDivisi } from "state/divisiActions";
import { fetchListJabatan } from "state/jabatanActions";
import KaryawanBaruModal from "components/Modals/KaryawanBaruModal";
import CustomFilterModal from "./CustomFilterModal";
import SortableHeader from "components/SortableHeader";
import moment from "moment";
import "moment/locale/id";
import { BASEURL } from "api/axiosInstance";
moment.locale("id");

const KaryawanBaru = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { list_karyawan } = useSelector((state) => state.karyawan);
  const {
    list_karyawan_web,
    pagination_karyawan_web,
    options_karyawan_web,
  } = useSelector((state) => state.karyawan);
  const { status, message } = useSelector((state) => state.global);
  const [openModalKaryawan, setOpenModalKaryawan] = useState(false);
  const [openKonfirmasi, setOpenKonfirmasi] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  const [openCustomFilter, setOpenCustomFilter] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [editData, setEditData] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({});
  const [openImagePreview, setOpenImagePreview] = useState(false);
  const [previewImageUrl, setPreviewImageUrl] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [page, setPage] = useState(0);

  const columnSort = [
    { value: "id_karyawan", label: "ID Karyawan" },
    { value: "nama_karyawan", label: "Nama Karyawan" },
    { value: "nama_jabatan", label: "Jabatan" },
    { value: "nama_cab", label: "Cabang" },
  ];

  const queryParams = useMemo(() => {
    const p = { page: page + 1, limit: rowsPerPage };
    const f = appliedFilters;
    if (f.search && f.search.trim() !== "") p.search = f.search.trim();
    if (f.filter?.nama_cab?.length) p.nama_cab = f.filter.nama_cab.join(",");
    if (f.filter?.nama_jabatan?.length)
      p.nama_jabatan = f.filter.nama_jabatan.join(",");
    if (f.filter?.nama_departemen?.length)
      p.nama_departemen = f.filter.nama_departemen.join(",");
    if (f.sort?.length) {
      const sortStr = f.sort
        .filter((s) => s.column)
        .map((s) => `${s.column}:${s.order}`)
        .join(",");
      if (sortStr) p.sort = sortStr;
    }
    return p;
  }, [page, rowsPerPage, appliedFilters]);

  useEffect(() => {
    dispatch(fetchListKaryawanWeb(queryParams));
  }, [dispatch, queryParams]);

  useEffect(() => {
    dispatch(fetchListKaryawan());
    dispatch(fetchListCabang());
    dispatch(fetchListDivisi());
    dispatch(fetchListJabatan());
    dispatch(fetchOptionsKaryawanWeb());
  }, []);

  const handleApplyCustomFilter = (filters) => {
    setPage(0);
    setAppliedFilters(filters);
  };

  const handleClearCustomFilter = () => {
    setPage(0);
    setAppliedFilters({});
  };

  const handleCloseSnackbar = () => {
    dispatch(setStatus("default"));
    dispatch(setMessage(""));
    dispatch(fetchListKaryawanWeb(queryParams));
    setSelectedData(null);
  };

  const handleSelectedData = (id) => {
    let currentSelectedData = list_karyawan_web.find(
      (item) => item.id_karyawan === id,
    );
    setSelectedData(currentSelectedData);
  };

  const handleSubmitKaryawan = (value) => {
    const formData = new FormData();

    // isi field biasa
    Object.entries({
      id_karyawan: selectedData ? selectedData.id_karyawan : null,
      nik: value.nik,
      nama_karyawan: value.nama,
      email: value.email,
      jenis_kelamin: value.jenis_kelamin,
      alamat: value.alamat,
      tanggal_lahir: value.tanggal_lahir,
      tanggal_mulai_kerja: value.tanggal_mulai_kerja,
      tanggal_akhir_kerja: value.tanggal_akhir_kerja,
      tipe_agunan: value.tipe_agunan,
      nama_bank: value.nama_bank,
      atas_nama_rekening: value.atas_nama_rekening,
      nomor_rekening: value.nomor_rekening,
      kode_jabatan: value.kode_jabatan,
      cabang: value.cabang,
      no_hp: value.no_hp,
      sikap: value.sikap,
      keterampilan: value.keterampilan,
      pengetahuan: value.pengetahuan,
      password: value.password,
      isEditPassword: selectedData && !editData ? true : false,
    }).forEach(([key, val]) => {
      if (val !== undefined && val !== null) {
        if (typeof val === "boolean") {
          formData.append(key, val ? "true" : "false");
        } else {
          formData.append(key, val);
        }
      }
    });

    // file khusus
    if (value.file_jenjang) {
      formData.append("file_jenjang", value.file_jenjang);
    }

    const debugData = {};
    formData.forEach((value, key) => {
      debugData[key] = value;
    });

    dispatch(fetchAddKaryawanBaru(formData));
    setSelectedData(null);
  };

  const handleDelete = () => {
    dispatch(fetchDeleteKaryawan(selectedData.id_karyawan));
    setOpenKonfirmasi(false);
    setSelectedData(null);
  };

  // Count active filters
  const getActiveFilterCount = () => {
    let count = 0;

    if (appliedFilters.filter) {
      if (appliedFilters.filter.nama_departemen?.length > 0) count++;
      if (appliedFilters.filter.nama_jabatan?.length > 0) count++;
      if (appliedFilters.filter.nama_cab?.length > 0) count++;
    }

    return count;
  };

  const columnsKaryawan = [
    {
      name: "id_karyawan",
      label: "ID Karyawan",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },
    {
      name: "nama_karyawan",
      label: "Nama Karyawan",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },
    {
      name: "nama_jabatan",
      label: "Jabatan",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },
    {
      name: "tanggal_berlaku",
      label: "Berlaku",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),

        customBodyRender: (value) => {
          if (!value) {
            return "-";
          }
          return moment(value).format("DD MMMM YYYY");
        },
      },
    },
    {
      name: "tanggal_berakhir",
      label: "Berakhir",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),

        customBodyRender: (value) => {
          if (!value) {
            return "-";
          }
          return moment(value).format("DD MMMM YYYY");
        },
      },
    },
    {
      name: "nama_cab",
      label: "Cabang",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },
    {
      name: "lama_kerja_hari",
      label: "Lama Kerja",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        customBodyRender: (value, tableMeta) => {
          const id_karyawan = tableMeta.rowData[0];
          if (id_karyawan !== "PRIMA00001") {
            return value + " Hari";
          }
        },
      },
    },
    {
      name: "tanggal_lahir",
      label: "Tanggal Lahir",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),

        customBodyRender: (value, tableMeta) => {
          if (!value) return "-";
          const id_karyawan = tableMeta.rowData[0];

          const tglLahir = moment(value);
          const hariIni = moment();

          // Cek apakah hari dan bulan sama dengan hari ini
          const isBirthday =
            tglLahir.date() === hariIni.date() &&
            tglLahir.month() === hariIni.month();

          return (
            <Box display="flex" alignItems="center" gap={1}>
              <Typography
                sx={{
                  fontWeight: isBirthday ? "bold" : "normal",
                  color: isBirthday ? "secondary.main" : "inherit", // Pembeda warna
                }}
              >
                {tglLahir.format("DD MMMM YYYY")}
              </Typography>

              {isBirthday && (
                <Tooltip title="Ulang Tahun Hari Ini!">
                  <IconButton
                    size="small"
                    color="secondary"
                    onClick={() =>
                      dispatch(fetchSendNotifBirthday(id_karyawan))
                    }
                    sx={{
                      animation: "pulse 1.5s infinite", // Opsional: efek berdenyut
                      "@keyframes pulse": {
                        "0%": { transform: "scale(1)" },
                        "50%": { transform: "scale(1.2)" },
                        "100%": { transform: "scale(1)" },
                      },
                    }}
                  >
                    <NotificationsActive fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          );
        },
      },
    },
    {
      name: "foto_qr",
      label: "Foto QR",
      options: {
        filter: false,
        sort: false,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        customBodyRender: (value, tableMeta) => {
          const fotoQrValue = tableMeta.rowData[8];

          if (!fotoQrValue) {
            return "-";
          }
          return (
            <Box
              component="img"
              src={`${BASEURL}/photos/${fotoQrValue}`}
              alt="Foto QR"
              sx={{
                width: 40,
                height: 40,
                objectFit: "cover",
                cursor: "pointer",
                borderRadius: 1,
                border: `1px solid ${theme.palette.divider}`,
              }}
              onClick={() => {
                setPreviewImageUrl(BASEURL + "/photos/" + fotoQrValue);
                setOpenImagePreview(true);
              }}
            />
          );
        },
      },
    },
    {
      name: "active",
      label: "Aktif",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        customBodyRender: (value, tableMeta) => {
          const id_karyawan = tableMeta.rowData[0];
          if (id_karyawan !== "PRIMA00001") {
            return (
              <FormControlLabel
                control={
                  <Switch
                    checked={value === "true"}
                    onChange={() =>
                      dispatch(
                        fetchChangeActiveKaryawan(
                          id_karyawan,
                          value === "true" ? "false" : "true",
                        ),
                      )
                    }
                    color="primary"
                  />
                }
                label={value === "true" ? "Aktif" : "Tidak Aktif"}
              />
            );
          }
        },
      },
    },
    {
      name: "aksi",
      label: "Aksi",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
          />
        ),
        customBodyRender: (value, tableMeta) => {
          const id = tableMeta.rowData[0];
          if (id !== "PRIMA00001") {
            return (
              <>
                <IconButton
                  color="info"
                  style={{ width: 20, height: 20 }}
                  size="small"
                  onClick={() => {
                    handleSelectedData(id);
                    setOpenDetail(true);
                  }}
                >
                  <Info style={{ width: 16, height: 16 }} />
                </IconButton>
                <IconButton
                  color="info"
                  style={{ width: 20, height: 20 }}
                  size="small"
                  onClick={() => {
                    handleSelectedData(id);
                    setEditData(false);
                    setOpenModalKaryawan(true);
                  }}
                >
                  <Password style={{ width: 16, height: 16 }} />
                </IconButton>
                <IconButton
                  color="info"
                  style={{ width: 20, height: 20 }}
                  size="small"
                  onClick={() => {
                    handleSelectedData(id);
                    setEditData(true);
                    setOpenModalKaryawan(true);
                  }}
                >
                  <Edit style={{ width: 16, height: 16 }} />
                </IconButton>
                <IconButton
                  color="error"
                  style={{ width: 20, height: 20 }}
                  size="small"
                  onClick={() => {
                    setOpenKonfirmasi(true);
                    handleSelectedData(id);
                  }}
                >
                  <Delete style={{ width: 16, height: 16 }} />
                </IconButton>
              </>
            );
          }
        },
      },
    },
  ];

  const options = {
    selectableRows: "none",
    filterType: "dropdown",
    filter: false,
    fixedHeader: false,
    fixedSelectColumn: false,
    search: true,
    viewColumns: false,
    responsive: "standard",
    customToolbar: () => {
      const activeCount = getActiveFilterCount();
      return (
        <Button
          startIcon={<FilterList />}
          onClick={() => setOpenCustomFilter(true)}
          variant={activeCount > 0 ? "contained" : "outlined"}
          size="small"
          color={activeCount > 0 ? "primary" : "inherit"}
          sx={{
            mr: 1,
            ...(activeCount === 0 && {
              color: "text.secondary",
              borderColor: "text.secondary",
            }),
          }}
        >
          Filter {activeCount > 0 && `(${activeCount})`}
        </Button>
      );
    },
    serverSide: true,
    count: pagination_karyawan_web?.total ?? 0,
    page: page,
    rowsPerPageOptions: [25, 50, 75],
    rowsPerPage: rowsPerPage,
    onChangePage: (currentPage) => setPage(currentPage),
    onChangeRowsPerPage: (numberOfRows) => {
      setRowsPerPage(numberOfRows);
      setPage(0);
    },
  };

  return (
    <Box m="1.5rem 2.5rem">
      <FlexBetween>
        <Header title="Karyawan" subtitle="Daftar karyawan perusahaan" />

        <Box>
          <Button
            sx={{
              backgroundColor: theme.palette.secondary.light,
              color: theme.palette.background.alt,
              fontSize: "14px",
              fontWeight: "bold",
              padding: "10px 20px",
              "&:hover": {
                backgroundColor: theme.palette.secondary.light,
              },
            }}
            onClick={() => {
              setOpenModalKaryawan(true);
              setSelectedData(null);
            }}
          >
            <Groups2Outlined sx={{ mr: "10px" }} />
            Tambah Karyawan
          </Button>
        </Box>
      </FlexBetween>
      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <MUIDataTable
          title={""}
          data={list_karyawan_web}
          columns={columnsKaryawan}
          options={options}
        />

        {/* Custom Filter Modal */}
        <CustomFilterModal
          open={openCustomFilter}
          onClose={() => setOpenCustomFilter(false)}
          onApplyFilter={handleApplyCustomFilter}
          onClearFilter={handleClearCustomFilter}
          data={list_karyawan_web}
          cabOptions={options_karyawan_web?.nama_cab ?? null}
          jabatanOptions={
            options_karyawan_web?.nama_jabatan
              ? options_karyawan_web.nama_jabatan
                  .map((j) => (j ? j.split(" - ")[0].trim() : ""))
                  .filter(Boolean)
                  .sort((a, b) => a.localeCompare(b))
              : null
          }
          departemenOptions={
            options_karyawan_web?.nama_jabatan
              ? options_karyawan_web.nama_jabatan
                  .map((j) => {
                    const parts = (j || "").split(" - ");
                    return parts.length > 0
                      ? parts[parts.length - 1].trim()
                      : "";
                  })
                  .filter(Boolean)
                  .sort((a, b) => a.localeCompare(b))
              : null
          }
          sortableColumns={columnSort}
        />

        <KaryawanBaruModal
          open={openModalKaryawan}
          editData={editData}
          onClose={() => setOpenModalKaryawan(false)}
          onSubmit={(value) => handleSubmitKaryawan(value)}
          dataEdit={selectedData}
        />
        <KonfirmasiModal
          titleType={"Hapus"}
          subtitleType={"Menghapus"}
          dataWillProses={selectedData?.id_karyawan}
          open={openKonfirmasi}
          onClose={() => setOpenKonfirmasi(false)}
          onSubmit={() => handleDelete()}
        />
        <DetailKaryawanModal
          dataDetail={selectedData}
          open={openDetail}
          onClose={() => {
            setSelectedData(null);
            setOpenDetail(false);
          }}
        />

        {/* Image Preview Modal */}
        <Dialog
          open={openImagePreview}
          onClose={() => setOpenImagePreview(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogContent
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: 2,
              backgroundColor: theme.palette.background.default,
            }}
          >
            <Box
              component="img"
              src={previewImageUrl}
              alt="Foto QR Preview"
              sx={{
                maxWidth: "100%",
                maxHeight: "70vh",
                objectFit: "contain",
              }}
            />
          </DialogContent>
        </Dialog>
      </Box>
      <FloatingAlert
        open={message.length > 0}
        onClose={handleCloseSnackbar}
        message={message}
        severity={status === "failed" ? "error" : status}
      />
    </Box>
  );
};

export default KaryawanBaru;
